import { useApi } from '@backstage/frontend-plugin-api';
import Badge from '@mui/material/Badge';
import { useQuery } from '@tanstack/react-query';

import { approvalApiRef } from '../apis';

export const ApprovalButton = () => {
  const approvalApi = useApi(approvalApiRef);

  const { data: approvals = [] } = useQuery(
    approvalApi.getApprovals.queryOptions(
      { filter: 'assignedToMe', status: 'pending' },
      { refetchInterval: 30_000 },
    ),
  );

  return (
    <Badge
      badgeContent={approvals.length}
      color="error"
      componentsProps={{
        badge: {
          'aria-label': 'Open Approvals',
          'role': 'status',
        },
      }}
      overlap="circular"
    >
      <img
        alt="Approvals"
        src="https://theme.ipen.eon.com/icons/navbar/approval.svg"
        width={32}
      />
    </Badge>
  );
};
